/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	DataRemovalRequestIndexPathParams,
	DataRemovalRequestIndexResponse,
} from '../types/DataRemovalRequestIndex'

/**
 * GET /organisations/:organisation/data-removal-requests
 * @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::index
 */
export async function dataRemovalRequestIndex(
	organisation: DataRemovalRequestIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<DataRemovalRequestIndexResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/data-removal-requests`, config)
}
